export default __webpack_public_path__ + "static/media/chat_disabled.9014b871.png";